<template>
  <div class="privacy-policy-page">
    <PrivacyPolicy />
  </div>
</template>

<script>
import PrivacyPolicy from '@/components/agent/PrivacyPolicy.vue'

export default {
  name: 'PrivacyPolicyPage',
  components: {
    PrivacyPolicy
  }
}
</script>

<style scoped>
.privacy-policy-page {
  padding: 20px;
}
</style>
